import { initComponents } from './components/components';
import { app } from './includes/firebase';

initComponents();

function loadProjectEventTrigger(eventName: string, eventElement: Element | null) {
  return () => {
    window.dispatchEvent(new CustomEvent(eventName, { detail: { button: eventElement } }));
  }
}

const loadMoreCommercials = document.querySelector("#loadMoreCommercials"),
  loadMoreProjects = document.querySelector("#loadMoreProjects");

loadMoreCommercials?.addEventListener(
  'click',
  loadProjectEventTrigger('commercial_load_more', loadMoreCommercials)
);

loadMoreProjects?.addEventListener(
  'click',
  loadProjectEventTrigger('project_load_more', loadMoreProjects)
);

const classesToPreserve = 'text-xl mb-1 pt-2 mb-2 mb-4 mb-3 text-orange-dark underline hover:text-accent-dark px-2 py-1 bg-gray-400 bg-purple-400 bg-blue-400 bg-green-400 rounded text-white mr-2 inline-block'